var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.42 22.9221C33.5991 22.8431 33.751 22.7134 33.857 22.5489C33.963 22.3845 34.0184 22.1925 34.0164 21.9969C34.0143 21.8012 33.955 21.6104 33.8456 21.4482C33.7362 21.286 33.5817 21.1594 33.401 21.0841L24.83 17.1801C24.5695 17.0613 24.2864 16.9998 24 16.9998C23.7137 16.9998 23.4306 17.0613 23.17 17.1801L14.6 21.0801C14.422 21.1581 14.2706 21.2862 14.1642 21.4489C14.0579 21.6116 14.0012 21.8018 14.0012 21.9961C14.0012 22.1905 14.0579 22.3806 14.1642 22.5433C14.2706 22.706 14.422 22.8341 14.6 22.9121L23.17 26.8201C23.4306 26.939 23.7137 27.0005 24 27.0005C24.2864 27.0005 24.5695 26.939 24.83 26.8201L33.42 22.9221Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 22V28",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24.5V28C18 28.7956 18.6321 29.5587 19.7574 30.1213C20.8826 30.6839 22.4087 31 24 31C25.5913 31 27.1174 30.6839 28.2426 30.1213C29.3679 29.5587 30 28.7956 30 28V24.5",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon4);
export default __webpack_public_path__ + "static/media/card-icon4.626afe709826b1835ce0f282dd5589fc.svg";
export { ForwardRef as ReactComponent };